/**
 * @generated SignedSource<<6cd3b9f9c6c8b7fe8b1e4ba3369818e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Tours_DemoRecordingQuery$variables = {};
export type Tours_DemoRecordingQuery$data = {
  readonly viewer: {
    readonly demoRecording: {
      readonly id: string;
      readonly note: {
        readonly id: string;
      } | null;
    };
  };
};
export type Tours_DemoRecordingQuery = {
  response: Tours_DemoRecordingQuery$data;
  variables: Tours_DemoRecordingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "Tours_DemoRecordingQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "demoRecording",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "Tours_DemoRecordingQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "demoRecording",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "caae8b7b3b7ccc2c19281c8808cd2758",
    "id": null,
    "metadata": {},
    "name": "Tours_DemoRecordingQuery",
    "operationKind": "query",
    "text": "query Tours_DemoRecordingQuery {\n  viewer {\n    demoRecording {\n      id\n      note {\n        __typename\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ee64652b910cebf1793108b1bcd872a7";

export default node;
